import styles from './styles.less';
import React from 'react';
import { Link } from 'react-router-dom';
 import cx from 'classnames';

import Comic from '../comics/comic';

class Content extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            shown: true,
            reverseOrder: false
        };
    }

    componentDidMount() {
        document.body.classList.add('noscroll');
    }

    componentWillUnmount() {
        document.body.classList.remove('noscroll');
    }

    render() {
        const data = this.props.data;
        const artist = this.props.artist;

        var className = cx(styles.root, this.props.className, {
            [styles.shown]: this.state.shown,
            [styles.hide]: !this.state.shown
        });

        if (data.reverse) data.comicsOrder = data.comics.slice(0).reverse();
        else {data.comicsOrder = data.comics}

        return (
            <div
                className={ className }
                onAnimationEnd={ this.handleAnimationEnd }>
                <Link
                    className={ styles.closeOverlay }
                    onClick={ this.handleOverlayClose }
                    to={ '/comics/' }>
                    <img
                        alt="Back to Comics"
                        src="https://i.cdn.turner.com/adultswim/big/img/2017/03/16/comics-back-button.png"
                    />
                </Link>

                <h2>{ data.title }</h2>
                <h3>
                    <a
                        href={ artist.artistSite }
                        target="_blank">{ artist.name }
                    </a>
                </h3>

                <div className={ styles.seriesComics }>
                    { data.comicsOrder.map((comic, i) => (
                        <Comic
                            key={ i }
                            comic={ comic }
                            data={ data }
                            title={ `${data.title} by ${artist.name}` }
                        />
                    )) }
                </div>
            </div>
        );

    }

    handleOverlayClose = () => {
        this.setState({
            shown: false
        });
    };
}


export default Content;



// WEBPACK FOOTER //
// ./src/client/components/series/index.js